module.exports = [{
      plugin: require('/Users/gana/dev/projects/swasth/health-coach-website/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/assets/images/healthcoach-favicon.png"},
    },{
      plugin: require('/Users/gana/dev/projects/swasth/health-coach-website/node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"/Users/gana/dev/projects/swasth/health-coach-website/src/cms/cms.js"},
    },{
      plugin: require('/Users/gana/dev/projects/swasth/health-coach-website/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/gana/dev/projects/swasth/health-coach-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
